import { render, staticRenderFns } from "./ViewContact.vue?vue&type=template&id=75c74f6c&"
import script from "./ViewContact.vue?vue&type=script&lang=js&"
export * from "./ViewContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports